import React, { lazy } from 'react';
import registry from '~/library/store/src/registry';

const GapComponent = lazy(
  () =>
    (import(
      /* webpackChunkName: "carvana-purchase-gap-waiver" */ '@carvana/purchase-gap-waiver'
    ) as unknown) as Promise<{ default: React.ComponentType<any> }>
);

const defaultProps = {
  GetDashboardAndRouteToNextStep: (_?: boolean) => {}
};

export const GapRoute = ({ GetDashboardAndRouteToNextStep } = defaultProps) => {
  return (
    <GapComponent
      registry={registry}
      dashboardActions={{
        GetDashboardAndRouteToNextStep
      }}
    />
  );
};
